import { Checkbox } from '@mui/material';
import { styled } from '@mui/material/styles';

export const LeadIconWrap = styled('span')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  marginRight: theme.spacing(1),
}));

/** Match compact IconButtons in RoomSelect inline rows (see global/components/room-select/styles inlineModal). */
export const PreviewActionCheckbox = styled(Checkbox)(({ theme }) => ({
  padding: 0,
  marginRight: theme.spacing(1),
}));
